/* SUNKISSED — Product gallery: fast photo switching + image zoom
   (loaded, deferred, by sections/sk-pdp-zoom.liquid)

   A. Fast switching. The theme swaps the big photo with a plain `img.src = ...`, so after a
      thumbnail or colour click the OLD photo stayed on screen until the new one had downloaded,
      with no sign that the click worked. Now:
        - the clicked thumbnail's small (already loaded) image is shown at once as a soft preview
        - the sharp photo fades in as soon as it arrives
        - photos are fetched ahead of time: the thumbnails visible in the strip (one at a time, in
          idle time) and any thumbnail the shopper hovers or touches
   B. Zoom. Desktop: hover magnifier + click for the full-screen viewer.
      Touch: tap to open, pinch, double-tap, drag to pan, swipe left/right, swipe down to close.

   Reads the existing gallery (#galMain, .gal-thumbs .th[data-full]) and never changes its markup. */
(function () {
  'use strict';
  var cfg = document.querySelector('[data-pdp-zoom]');
  var main = document.querySelector('.gal-main');
  var mainImg = document.getElementById('galMain');
  if (!cfg || !main || !mainImg) return;

  var LEVEL = parseFloat(cfg.getAttribute('data-level')) || 2.5;
  var MAX = Math.max(4, LEVEL);
  var HOVER = cfg.getAttribute('data-hover') !== 'false';
  var BUTTON = cfg.getAttribute('data-button') !== 'false';
  var HINT = cfg.getAttribute('data-hint') || '';
  var TITLE = cfg.getAttribute('data-title') || 'Product';
  var HIRES = 2000;

  /* Shopify image URLs carry a width parameter; ask for a larger rendition of the same file. */
  function sized(u, w) {
    if (!u) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function key(u) { return (u || '').replace(/^https?:/, '').replace(/[?&]width=\d+/, '').replace(/[?&]$/, ''); }

  function thumbs() { return [].slice.call(document.querySelectorAll('.gal-thumbs .th[data-full]')); }
  function imageList() {
    var t = thumbs().map(function (x) { return x.getAttribute('data-full'); });
    if (!t.length) t = [mainImg.getAttribute('src')];
    return t;
  }
  function currentIndex(list) {
    var cur = key(mainImg.getAttribute('src'));
    for (var i = 0; i < list.length; i++) { if (key(list[i]) === cur) return i; }
    return 0;
  }

  main.classList.add('sk-zm-on');

  /* ==================== A. Fast photo switching ==================== */
  var ready = {};            /* key -> true once that photo is in the browser cache */
  var lens = null, lensFor = '';

  function preload(url) {
    var k = key(url);
    if (!url || ready[k] === true || ready[k] === 'pending') return;
    ready[k] = 'pending';
    var im = new Image();
    im.decoding = 'async';
    im.onload = function () { ready[k] = true; };
    im.onerror = function () { delete ready[k]; };
    im.src = url;
  }
  function thumbSrcFor(k) {
    var list = thumbs();
    for (var i = 0; i < list.length; i++) {
      if (key(list[i].getAttribute('data-full')) === k) {
        var im = list[i].querySelector('img');
        return im ? (im.currentSrc || im.src) : '';
      }
    }
    return '';
  }
  function resetLens() { lensFor = ''; if (lens) lens.classList.remove('is-ready'); }
  function swapDone() {
    ready[key(mainImg.getAttribute('src'))] = true;
    main.classList.remove('is-swapping');
    main.style.backgroundImage = '';
    if (lens && main.classList.contains('is-zooming')) prepLens();
  }

  if (mainImg.complete && mainImg.naturalWidth > 0) ready[key(mainImg.getAttribute('src'))] = true;
  mainImg.addEventListener('load', swapDone);
  mainImg.addEventListener('error', swapDone);

  /* Whoever changes the big photo (thumbnail click, colour change), react the moment src changes */
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      resetLens();
      if (mainImg.complete && mainImg.naturalWidth > 0) { swapDone(); return; }
      var preview = thumbSrcFor(key(mainImg.getAttribute('src')));
      if (preview) main.style.backgroundImage = 'url("' + preview + '")';
      main.classList.add('is-swapping');
    }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
  }

  /* Fetch ahead, 1: the thumbnail the shopper is about to use */
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.gal-thumbs .th[data-full]') : null;
      if (t) preload(t.getAttribute('data-full'));
    }, { capture: true, passive: true });
  });

  /* Fetch ahead, 2: the thumbnails currently visible in the strip (those are the ones that get
     clicked). One download at a time, only in idle time, so it never competes with the page.
     As the strip is scrolled, newly visible thumbnails join the queue.
     Skipped entirely on data-saver and very slow connections. */
  var queue = [], running = false;
  function whenIdle(fn) { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 4000 }); else setTimeout(fn, 1500); }
  function pump() {
    if (running) return;
    var u = queue.shift();
    if (!u) return;
    var k = key(u);
    if (ready[k]) { pump(); return; }
    running = true;
    ready[k] = 'pending';
    var im = new Image();
    im.decoding = 'async';
    im.onload = function () { ready[k] = true; running = false; pump(); };
    im.onerror = function () { delete ready[k]; running = false; pump(); };
    im.src = u;
  }
  function startIdlePreload() {
    var c = navigator.connection || {};
    if (c.saveData || /2g/.test(c.effectiveType || '')) return;
    var list = thumbs();
    if (!list.length) return;
    if (!('IntersectionObserver' in window)) {
      list.slice(0, 4).forEach(function (t) { queue.push(t.getAttribute('data-full')); });
      whenIdle(pump);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        queue.push(en.target.getAttribute('data-full'));
        io.unobserve(en.target);
      });
      whenIdle(pump);
    }, { threshold: 0.5 });
    list.forEach(function (t) { io.observe(t); });
  }
  if (document.readyState === 'complete') whenIdle(startIdlePreload);
  else window.addEventListener('load', function () { whenIdle(startIdlePreload); });

  /* ==================== B. Zoom ==================== */

  /* ---------- Desktop hover magnifier ---------- */
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  function prepLens() {
    if (!lens) return;
    /* never magnify while the big photo is still switching: the sharp photo gets the bandwidth first */
    if (main.classList.contains('is-swapping')) return;
    var src = sized(mainImg.getAttribute('src'), HIRES);
    if (src === lensFor) return;
    lensFor = src;
    lens.classList.remove('is-ready');
    var im = new Image();
    im.onload = function () {
      if (lensFor !== src) return;
      /* The photo fills a square with object-fit: cover, so magnify along the axis that "covers". */
      var pct = (LEVEL * 100) + '%';
      lens.style.backgroundSize = im.naturalWidth >= im.naturalHeight ? 'auto ' + pct : pct + ' auto';
      lens.style.backgroundImage = 'url("' + src + '")';
      lens.classList.add('is-ready');
    };
    im.src = src;
  }
  if (HOVER) {
    lens = document.createElement('div');
    lens.className = 'sk-zm-hover';
    lens.setAttribute('aria-hidden', 'true');
    main.appendChild(lens);
    main.addEventListener('mouseenter', function () { if (!finePointer.matches) return; main.classList.add('is-zooming'); prepLens(); });
    main.addEventListener('mousemove', function (e) {
      if (!finePointer.matches) return;
      if (!main.classList.contains('is-zooming')) { main.classList.add('is-zooming'); }
      prepLens();
      var r = main.getBoundingClientRect();
      var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
      var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
      lens.style.backgroundPosition = x + '% ' + y + '%';
    });
    main.addEventListener('mouseleave', function () { main.classList.remove('is-zooming'); });
  }

  /* ---------- Full-screen viewer ---------- */
  var lb, stage, img, countEl, prevBtn, nextBtn, closeBtn;
  var list = [], idx = 0, s = 1, tx = 0, ty = 0, lastFocus = null;

  var ICON_ZOOM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5M11 8v6M8 11h6"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  function build() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'sk-zm';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', TITLE + ' — photos');
    lb.innerHTML =
      '<button type="button" class="sk-zm-close" aria-label="Close">' + ICON_X + '</button>' +
      '<button type="button" class="sk-zm-nav sk-zm-prev" aria-label="Previous photo">\u2039</button>' +
      '<button type="button" class="sk-zm-nav sk-zm-next" aria-label="Next photo">\u203A</button>' +
      '<div class="sk-zm-stage"><img class="sk-zm-img" alt="" draggable="false"></div>' +
      '<div class="sk-zm-foot"><span class="sk-zm-count" aria-live="polite"></span><span class="sk-zm-hint"></span></div>';
    document.body.appendChild(lb);
    stage = lb.querySelector('.sk-zm-stage');
    img = lb.querySelector('.sk-zm-img');
    countEl = lb.querySelector('.sk-zm-count');
    prevBtn = lb.querySelector('.sk-zm-prev');
    nextBtn = lb.querySelector('.sk-zm-next');
    closeBtn = lb.querySelector('.sk-zm-close');
    lb.querySelector('.sk-zm-hint').textContent = HINT;
    img.alt = TITLE;

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(idx - 1); });
    nextBtn.addEventListener('click', function () { show(idx + 1); });
    bindGestures();
  }

  function apply(animate) {
    img.style.transition = animate ? 'transform .22s ease' : 'none';
    img.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + s + ')';
    lb.classList.toggle('is-zoomed', s > 1.01);
  }
  function clamp() {
    var r = stage.getBoundingClientRect();
    var mx = Math.max(0, (img.offsetWidth * s - r.width) / 2);
    var my = Math.max(0, (img.offsetHeight * s - r.height) / 2);
    tx = Math.min(mx, Math.max(-mx, tx));
    ty = Math.min(my, Math.max(-my, ty));
  }
  /* Zoom so that the point under the finger / cursor stays where it is */
  function zoomAt(ns, cx, cy, animate) {
    ns = Math.min(MAX, Math.max(1, ns));
    var r = stage.getBoundingClientRect();
    var px = cx - (r.left + r.width / 2);
    var py = cy - (r.top + r.height / 2);
    tx = (tx - px) * (ns / s) + px;
    ty = (ty - py) * (ns / s) + py;
    s = ns;
    if (s <= 1.01) { s = 1; tx = 0; ty = 0; }
    clamp();
    apply(animate);
  }
  function toggleZoom(cx, cy) { if (s > 1.01) zoomAt(1, cx, cy, true); else zoomAt(LEVEL, cx, cy, true); }

  function show(i) {
    if (!list.length) return;
    idx = (i + list.length) % list.length;
    s = 1; tx = 0; ty = 0;
    img.src = sized(list[idx], HIRES);
    apply(false);
    countEl.textContent = list.length > 1 ? (idx + 1) + ' / ' + list.length : '';
    prevBtn.hidden = nextBtn.hidden = list.length < 2;
  }

  function open() {
    build();
    list = imageList();
    lastFocus = document.activeElement;
    lb.hidden = false;
    show(currentIndex(list));
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { lb.classList.add('is-open'); });
    closeBtn.focus();
    document.addEventListener('keydown', onKey);
  }
  function close() {
    if (!lb || lb.hidden) return;
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { lb.hidden = true; img.removeAttribute('src'); }, 200);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(); }
    else if (e.key === 'ArrowLeft') { show(idx - 1); }
    else if (e.key === 'ArrowRight') { show(idx + 1); }
    else if (e.key === 'Tab') {
      /* keep focus inside the viewer */
      var f = [closeBtn, prevBtn, nextBtn].filter(function (b) { return !b.hidden && b.offsetParent !== null; });
      if (!f.length) { e.preventDefault(); return; }
      var at = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(at + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
    }
  }

  function bindGestures() {
    var pts = {}, startDist = 0, startS = 1, moved = false, downX = 0, downY = 0, pan = { tx: 0, ty: 0 }, lastTap = 0, pinched = false;

    function ids() { return Object.keys(pts); }

    stage.addEventListener('pointerdown', function (e) {
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var k = ids();
      if (k.length === 1) {
        downX = e.clientX; downY = e.clientY; moved = false; pinched = false; pan = { tx: tx, ty: ty };
      } else if (k.length === 2) {
        var a = pts[k[0]], b = pts[k[1]];
        startDist = Math.hypot(a.x - b.x, a.y - b.y) || 1;
        startS = s; moved = true; pinched = true;
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var k = ids();
      if (k.length >= 2) {
        var a = pts[k[0]], b = pts[k[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y) || 1;
        zoomAt(startS * d / startDist, (a.x + b.x) / 2, (a.y + b.y) / 2, false);
        return;
      }
      var dx = e.clientX - downX, dy = e.clientY - downY;
      if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
      if (!moved) return;
      if (s > 1.01) { tx = pan.tx + dx; ty = pan.ty + dy; clamp(); apply(false); }
      else if (!pinched && e.pointerType !== 'mouse') {
        /* follow the finger a little so swipes feel connected */
        if (Math.abs(dx) > Math.abs(dy) && list.length > 1) { tx = dx; ty = 0; } else { tx = 0; ty = Math.max(0, dy); }
        apply(false);
      }
    });

    function end(e) {
      if (!pts[e.pointerId]) return;
      delete pts[e.pointerId];
      var k = ids();
      if (k.length === 1) {
        /* one finger left after a pinch: continue as a pan from here, without a jump */
        var p = pts[k[0]]; downX = p.x; downY = p.y; pan = { tx: tx, ty: ty }; moved = true;
        return;
      }
      if (k.length) return;

      var dx = e.clientX - downX, dy = e.clientY - downY;
      if (s <= 1.01 && !pinched && moved && e.pointerType !== 'mouse') {
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) && list.length > 1) { show(idx + (dx < 0 ? 1 : -1)); return; }
        if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { close(); return; }
        tx = 0; ty = 0; apply(true);
        return;
      }
      if (moved) { if (s <= 1.01) { tx = 0; ty = 0; apply(true); } return; }

      /* A tap / click without movement */
      var r = img.getBoundingClientRect();
      var onImage = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (e.pointerType === 'mouse') {
        if (!onImage && s <= 1.01) { close(); return; }
        toggleZoom(e.clientX, e.clientY);
      } else {
        var now = Date.now();
        if (now - lastTap < 320) { lastTap = 0; toggleZoom(e.clientX, e.clientY); }
        else { lastTap = now; }
      }
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);

    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomAt(s * (e.deltaY < 0 ? 1.2 : 1 / 1.2), e.clientX, e.clientY, false);
    }, { passive: false });

    window.addEventListener('resize', function () { if (lb && !lb.hidden) { clamp(); apply(false); } });
  }

  /* ---------- Open triggers ---------- */
  if (BUTTON) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sk-zm-btn';
    btn.setAttribute('aria-label', 'Zoom photo');
    btn.innerHTML = ICON_ZOOM;
    main.appendChild(btn);
  }
  main.addEventListener('click', function (e) {
    var ctl = e.target.closest('button, a');
    if (ctl && !ctl.classList.contains('sk-zm-btn')) return; /* leave other controls on the photo alone */
    e.preventDefault();
    open();
  });
})();
